var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "rounded-lg" },
    [
      _c("v-card-title", [_vm._v("Branding")]),
      _c("v-divider"),
      _c("v-card-text", [_vm._v(" Branding settings...!! ")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }